import { useState } from "react";
import { ChevronDown, CircleCheck, MessageSquareWarning } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ChartCard, ChartEmpty } from "./ui";
import { cn } from "@/lib/utils";

const INITIAL_SHOW = 5;

const TopFailingQuestions = ({ questions }: any) => {
  const [expanded, setExpanded] = useState(false);

  if (!questions || questions.length === 0) {
    return (
      <ChartCard icon={<MessageSquareWarning />} title="Top Unanswered Questions" description="Add these to your FAQs to improve answers.">
        <ChartEmpty icon={<CircleCheck />} text="Great — no unanswered questions found!" />
      </ChartCard>
    );
  }

  const allQuestions = questions.slice(0, 10);
  const visible = expanded ? allQuestions : allQuestions.slice(0, INITIAL_SHOW);
  const hasMore = allQuestions.length > INITIAL_SHOW;

  return (
    <ChartCard
      icon={<MessageSquareWarning />}
      title={<>Top Unanswered Questions <span className="uq-count-badge rounded-full bg-destructive/10 px-2 py-0.5 text-xs font-medium text-destructive">{allQuestions.length}</span></>}
      description="Add these to your FAQs to improve answers."
      className="uq-section"
    >
      <ol className="uq-grid grid gap-2 md:grid-cols-2">
        {visible.map((q, idx) => (
          <li key={idx} className="uq-chip flex items-center gap-3 rounded-lg border border-border bg-background px-3 py-2 text-sm">
            <span className="uq-chip-rank flex size-6 shrink-0 items-center justify-center rounded-full bg-primary/10 text-xs font-semibold text-primary">{idx + 1}</span>
            <span className="uq-chip-text min-w-0 flex-1 truncate" title={q.question}>{q.question}</span>
            <span className="uq-chip-count shrink-0 rounded-full bg-secondary px-2 py-0.5 text-xs font-medium text-secondary-foreground">{q.count}x</span>
          </li>
        ))}
      </ol>
      {hasMore && (
        <Button type="button" variant="ghost" size="sm" className="uq-toggle-btn self-center" onClick={() => setExpanded(!expanded)}>
          {expanded ? "Show less" : `Show ${allQuestions.length - INITIAL_SHOW} more`}
          <ChevronDown className={cn("transition-transform", expanded && "rotate-180")} aria-hidden="true" />
        </Button>
      )}
    </ChartCard>
  );
};

export default TopFailingQuestions;
